module.exports = __webpack_public_path__ + "img/realLeaf1.974075f8.png";